import { serverErrors } from 'helpers/api_errors';

export const SAVE_ERROR_TEXT = 'An error occurred. Please retry in a few seconds.';

export function saveErrorText(errors) {
  const messages = serverErrors(errors)
    .filter(message => typeof message === 'string').map(message => message.trim()).filter(Boolean);

  return messages.length > 0 ? messages.join('; ') : SAVE_ERROR_TEXT;
}
